// extracted by mini-css-extract-plugin
export default {"root":"root_KRXN","image":"image_Fs90","content":"content_oIQC","title":"title_Ut4b","description":"description_aGav","cta":"cta_l4ik"};